import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X, Shield } from 'lucide-react';
import { useAuth } from '../../pages/AuthContext';

const WeakPasswordAlert = () => {
  const { weakPasswordInfo, dismissWeakPasswordWarning } = useAuth();

  if (!weakPasswordInfo?.isWeak) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4"
      >
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-6 w-6 text-yellow-600" />
          </div>
          <div className="ml-3 flex-1">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-yellow-800 flex items-center gap-2">
                <Shield className="h-4 w-4" />
                Cambia tu contraseña por una más segura
              </h3>
              <button
                onClick={dismissWeakPasswordWarning}
                className="ml-auto flex-shrink-0 inline-flex text-yellow-600 hover:text-yellow-800"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="mt-2 text-sm text-yellow-700">
              <p className="font-semibold">Tu contraseña actual no cumple con los requisitos de seguridad:</p>
              <ul className="mt-2 list-disc list-inside space-y-1">
                {weakPasswordInfo.requirements.map((requirement, index) => (
                  <li key={index}>{requirement}</li>
                ))}
              </ul>
              <p className="mt-3 font-semibold">
                Por favor, actualiza tu contraseña en la página de Perfil para mantener tu cuenta segura.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default WeakPasswordAlert;

